import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"

function Uri(props) {
    let uri = props.uri
    let url = props.url
    if (url) return <a target="_blank" href={url} rel="noopener noreferrer" {...props} />
    return <Link to={uri} {...props} />
}
export default Uri